<eps-filter-list
  [list]="list"
  [loading]="listIsLoading()"
  [executeDisabled]="isDisabled()"
  [paging]="paging"
  [pageSizeOptions]="[25,50,100]"
  [localDataPaging]="true"
  [displayedColumns]="['sender', 'receiver', 'activeFrom', 'activeTo', 'senderRole', 'receiverRole']"
  filterButtonLabel="HOME_MARKET_BONUS.FILTER.TITLE"
  header="SHARED.HEADER.HOME_MARKET_BONUS"
  (filterOrPagingChanged)="executeFilter($event)"
>
  <app-home-market-bonus-filter
    filter
    [senderShipTos]="sandbox.senderShipTos$ | async"
    [receiverShipTos]="sandbox.receiverShipTos$ | async"
    [shipTosLoading]="sandbox.shipTosLoading$ | async"
    [form]="filterForm"
  ></app-home-market-bonus-filter>

  <div class="tableheader" tableheader>
    <div>
      <eps-button
        label="HOME_MARKET_BONUS.TABLE.LEGEND.BUTTONS.SHOW"
        (buttonClick)="legendVisible.set(true)"
      ></eps-button>
      <eps-button
        label="HOME_MARKET_BONUS.TABLE.DOWNLOAD"
        buttonIcon="download"
        (buttonClick)="downloadList()"
        [busy]="isDownloading()"
      ></eps-button>
    </div>
  </div>

  <ng-container filter-buttons>
    <eps-button
      (buttonClick)="resetFilter()"
      buttonIcon="eraser"
      minWidth="160px"
      label="SHARED.BUTTONS.CLEAR_FILTERS"
    ></eps-button>
  </ng-container>

  <ng-template table-column column="sender" label="HOME_MARKET_BONUS.TABLE.SENDER" [sort]="true" let-hmb [valueGetter]="nameGetter('sender')"> {{ hmb.sender.name }}</ng-template>
  <ng-template table-column column="receiver" label="HOME_MARKET_BONUS.TABLE.RECEIVER" [sort]="true" let-hmb [valueGetter]="nameGetter('receiver')"> {{ hmb.receiver.name }}</ng-template>
  <ng-template table-column column="activeFrom" label="HOME_MARKET_BONUS.TABLE.STATE_FROM" [sort]="true" let-hmb> {{ hmb.activeFrom | date:'dd/MM/yyyy' }}</ng-template>
  <ng-template table-column column="activeTo" label="HOME_MARKET_BONUS.TABLE.STATE_TO" [sort]="true" let-hmb> {{ hmb.activeTo | date:'dd/MM/yyyy' }}</ng-template>
  <ng-template table-column column="senderRole" label="HOME_MARKET_BONUS.TABLE.SENDER_ROLE" [sort]="true" let-hmb> {{ hmb.senderRole |translateRole }}</ng-template>
  <ng-template table-column column="receiverRole" label="HOME_MARKET_BONUS.TABLE.RECEIVER_ROLE" [sort]="true" let-hmb> {{ hmb.receiverRole |translateRole }}</ng-template>

</eps-filter-list>

<eps-dialog
  *ngIf="legendVisible()"
  titleFirstPart="HOME_MARKET_BONUS.TABLE.LEGEND.TITLE.PART1"
  titleLastPart="HOME_MARKET_BONUS.TABLE.LEGEND.TITLE.PART2"
>
  <div content [innerHTML]="'HOME_MARKET_BONUS.TABLE.LEGEND.DETAILS' | translate">
  </div>
  <div buttons>
    <eps-button label="HOME_MARKET_BONUS.TABLE.LEGEND.BUTTONS.CLOSE" (buttonClick)="legendVisible.set(false)"></eps-button>
  </div>
</eps-dialog>
